var _path, _circle, _path2, _circle2, _path3, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path4, _path5, _path6, _g, _g2, _g3, _path7, _rect25, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopLeftImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 710.538,
    height: 478.668,
    viewBox: "0 0 710.538 478.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_8839",
    "data-name": "Group 8839",
    transform: "translate(-114.999 -374.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8802",
    "data-name": "Group 8802",
    transform: "translate(175.113 374.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8833",
    "data-name": "Group 8833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8820",
    "data-name": "Group 8820",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10827",
    "data-name": "Path 10827",
    d: "M341.283,346.107a131.072,131.072,0,0,1,10.851-41.367q2.448-5.469,5.389-10.7a.8.8,0,1,0-1.382-.806,132.882,132.882,0,0,0-14.786,40.793q-1.11,6-1.669,12.075C339.592,347.13,341.189,347.124,341.283,346.107Z",
    transform: "translate(-289.126 -207.109)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_365",
    "data-name": "Ellipse 365",
    cx: 10.111,
    cy: 10.111,
    r: 10.111,
    transform: "translate(62.15 69.272)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10828",
    "data-name": "Path 10828",
    d: "M342.211,345.073a85.038,85.038,0,0,1,7.038-26.837q1.589-3.548,3.5-6.94a.518.518,0,1,0-.894-.523,86.209,86.209,0,0,0-9.593,26.464q-.72,3.89-1.082,7.836C341.112,345.736,342.148,345.732,342.211,345.073Z",
    transform: "translate(-289.018 -205.805)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_366",
    "data-name": "Ellipse 366",
    cx: 6.559,
    cy: 6.559,
    r: 6.559,
    transform: "translate(59.674 94.032)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10829",
    "data-name": "Path 10829",
    d: "M341.848,344.424a85.037,85.037,0,0,1-10.957-25.489q-.93-3.775-1.512-7.623a.518.518,0,0,0-1.027.138,86.207,86.207,0,0,0,8.714,26.769q1.825,3.51,3.966,6.844C341.392,345.624,342.207,344.984,341.848,344.424Z",
    transform: "translate(-289.965 -205.778)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 6.559,
    cy: 6.559,
    r: 6.559,
    transform: "translate(31.82 93.573)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10830",
    "data-name": "Path 10830",
    d: "M322.169,348.747V335.859A4.839,4.839,0,0,1,327,331.026h30.072a4.838,4.838,0,0,1,4.833,4.833v12.888a4.839,4.839,0,0,1-4.833,4.833H327A4.838,4.838,0,0,1,322.169,348.747Z",
    transform: "translate(-290.422 -204.295)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10831",
    "data-name": "Path 10831",
    d: "M354.89,275.318H342a4.838,4.838,0,0,1-4.833-4.833V217.859A4.838,4.838,0,0,1,342,213.026H354.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.839,4.839,0,0,1-4.832,4.833Z",
    transform: "translate(-289.313 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    "data-name": "Rectangle 1688",
    width: 21.48,
    height: 4.296,
    transform: "translate(48.394 10.203)",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    "data-name": "Rectangle 1689",
    width: 21.48,
    height: 4.296,
    transform: "translate(48.394 43.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10832",
    "data-name": "Path 10832",
    d: "M384.89,275.318H372a4.838,4.838,0,0,1-4.833-4.833V217.859A4.838,4.838,0,0,1,372,213.026H384.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.838,4.838,0,0,1-4.832,4.833Z",
    transform: "translate(-287.093 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1690",
    "data-name": "Rectangle 1690",
    width: 21.48,
    height: 4.296,
    transform: "translate(80.614 10.203)",
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691",
    "data-name": "Rectangle 1691",
    width: 21.48,
    height: 4.296,
    transform: "translate(80.614 43.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10833",
    "data-name": "Path 10833",
    d: "M414.89,275.318H402a4.838,4.838,0,0,1-4.833-4.833V217.859A4.839,4.839,0,0,1,402,213.026H414.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.838,4.838,0,0,1-4.832,4.833Z",
    transform: "translate(-284.873 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692",
    "data-name": "Rectangle 1692",
    width: 21.48,
    height: 4.296,
    transform: "translate(112.834 10.203)",
    fill: "#ccc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693",
    "data-name": "Rectangle 1693",
    width: 21.48,
    height: 4.296,
    transform: "translate(112.834 43.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10834",
    "data-name": "Path 10834",
    d: "M430.89,356.318H418a4.839,4.839,0,0,1-4.833-4.833V298.859A4.839,4.839,0,0,1,418,294.026H430.89a4.839,4.839,0,0,1,4.833,4.833v52.626A4.839,4.839,0,0,1,430.89,356.318Z",
    transform: "translate(-283.688 -207.032)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694",
    "data-name": "Rectangle 1694",
    width: 21.48,
    height: 4.296,
    transform: "translate(130.018 97.197)",
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695",
    "data-name": "Rectangle 1695",
    width: 21.48,
    height: 4.296,
    transform: "translate(130.018 130.49)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10835",
    "data-name": "Path 10835",
    d: "M460.89,356.318H448a4.839,4.839,0,0,1-4.833-4.833V298.859A4.839,4.839,0,0,1,448,294.026H460.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.839,4.839,0,0,1-4.832,4.833Z",
    transform: "translate(-281.468 -207.032)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696",
    "data-name": "Rectangle 1696",
    width: 21.48,
    height: 4.296,
    transform: "translate(162.237 97.197)",
    fill: "#ccc"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697",
    "data-name": "Rectangle 1697",
    width: 21.48,
    height: 4.296,
    transform: "translate(162.237 130.49)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10836",
    "data-name": "Path 10836",
    d: "M490.89,356.318H478a4.838,4.838,0,0,1-4.833-4.833V298.859A4.839,4.839,0,0,1,478,294.026H490.89a4.839,4.839,0,0,1,4.833,4.833v52.626A4.839,4.839,0,0,1,490.89,356.318Z",
    transform: "translate(-279.248 -207.032)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698",
    "data-name": "Rectangle 1698",
    width: 21.48,
    height: 4.296,
    transform: "translate(194.458 97.197)",
    fill: "#ccc"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699",
    "data-name": "Rectangle 1699",
    width: 21.48,
    height: 4.296,
    transform: "translate(194.458 130.49)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10837",
    "data-name": "Path 10837",
    d: "M351.89,437.318H339a4.838,4.838,0,0,1-4.833-4.833V379.859A4.839,4.839,0,0,1,339,375.026H351.89a4.839,4.839,0,0,1,4.833,4.833v52.626a4.838,4.838,0,0,1-4.833,4.833Z",
    transform: "translate(-289.535 -201.039)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1700",
    "data-name": "Rectangle 1700",
    width: 21.48,
    height: 4.296,
    transform: "translate(45.173 184.191)",
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 21.48,
    height: 4.296,
    transform: "translate(45.173 217.484)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10838",
    "data-name": "Path 10838",
    d: "M381.89,437.318H369a4.838,4.838,0,0,1-4.833-4.833V379.859A4.839,4.839,0,0,1,369,375.026H381.89a4.839,4.839,0,0,1,4.833,4.833v52.626a4.839,4.839,0,0,1-4.833,4.833Z",
    transform: "translate(-287.314 -201.039)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 21.48,
    height: 4.296,
    transform: "translate(77.392 184.191)",
    fill: "#ccc"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703",
    "data-name": "Rectangle 1703",
    width: 21.48,
    height: 4.296,
    transform: "translate(77.392 217.484)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10839",
    "data-name": "Path 10839",
    d: "M411.89,437.318H399a4.838,4.838,0,0,1-4.833-4.833V379.859A4.839,4.839,0,0,1,399,375.026H411.89a4.839,4.839,0,0,1,4.833,4.833v52.626a4.839,4.839,0,0,1-4.833,4.833Z",
    transform: "translate(-285.094 -201.039)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    "data-name": "Rectangle 1704",
    width: 21.48,
    height: 4.296,
    transform: "translate(109.613 184.191)",
    fill: "#ccc"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1705",
    "data-name": "Rectangle 1705",
    width: 21.48,
    height: 4.296,
    transform: "translate(109.613 217.484)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10840",
    "data-name": "Path 10840",
    d: "M444.89,275.318H432a4.838,4.838,0,0,1-4.833-4.833V217.859A4.838,4.838,0,0,1,432,213.026H444.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.839,4.839,0,0,1-4.832,4.833Z",
    transform: "translate(-282.653 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1706",
    "data-name": "Rectangle 1706",
    width: 21.48,
    height: 4.296,
    transform: "translate(145.054 10.203)",
    fill: "#ccc"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 21.48,
    height: 4.296,
    transform: "translate(145.054 43.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10841",
    "data-name": "Path 10841",
    d: "M474.89,275.318H462a4.838,4.838,0,0,1-4.833-4.833V217.859A4.838,4.838,0,0,1,462,213.026H474.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.838,4.838,0,0,1-4.833,4.833Z",
    transform: "translate(-280.433 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708",
    "data-name": "Rectangle 1708",
    width: 21.48,
    height: 4.296,
    transform: "translate(177.274 10.203)",
    fill: "#ccc"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    "data-name": "Rectangle 1709",
    width: 21.48,
    height: 4.296,
    transform: "translate(177.274 43.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10842",
    "data-name": "Path 10842",
    d: "M504.89,275.318H492a4.838,4.838,0,0,1-4.833-4.833V217.859A4.838,4.838,0,0,1,492,213.026H504.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.838,4.838,0,0,1-4.832,4.833Z",
    transform: "translate(-278.213 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 21.48,
    height: 4.296,
    transform: "translate(209.494 10.203)",
    fill: "#ccc"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 21.48,
    height: 4.296,
    transform: "translate(209.494 43.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10843",
    "data-name": "Path 10843",
    d: "M534.89,275.318H522a4.839,4.839,0,0,1-4.833-4.833V217.859A4.839,4.839,0,0,1,522,213.026H534.89a4.838,4.838,0,0,1,4.833,4.833v52.626a4.838,4.838,0,0,1-4.832,4.833Z",
    transform: "translate(-275.993 -213.026)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 21.48,
    height: 4.296,
    transform: "translate(241.714 10.203)",
    fill: "#ccc"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    "data-name": "Rectangle 1713",
    width: 21.48,
    height: 4.296,
    transform: "translate(241.714 43.496)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10844",
    "data-name": "Path 10844",
    d: "M599.774,272.674H293.685a1.074,1.074,0,1,1,0-2.148h306.09a1.074,1.074,0,0,1,0,2.148Z",
    transform: "translate(-292.61 -208.771)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10845",
    "data-name": "Path 10845",
    d: "M599.774,353.674H293.685a1.074,1.074,0,1,1,0-2.148h306.09a1.074,1.074,0,0,1,0,2.148Z",
    transform: "translate(-292.61 -202.778)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10846",
    "data-name": "Path 10846",
    d: "M599.774,434.674H293.685a1.074,1.074,0,1,1,0-2.148h306.09a1.074,1.074,0,0,1,0,2.148Z",
    transform: "translate(-292.61 -196.784)",
    fill: "#ccc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8815",
    "data-name": "Group 8815",
    transform: "translate(33.427 286.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M733.246,514.339c0-3.9-1.309-7.063-2.917-7.071H292.064c-1.615.007-2.917,3.172-2.924,7.071v160.5a1.455,1.455,0,0,1-1.316,1.451q-1.764.169-3.529.315c-.029,0-.058.007-.087.007-.64.058-1.28.1-1.92.153h-.007q-.494-.913-.976-1.842a1.463,1.463,0,0,1-.166-.676V505.167c0-1.077.044-2.16.116-3.23a41.377,41.377,0,0,1,.546-4.379c1.229-6.758,4.008-11.333,7.165-11.348H733.42a3.405,3.405,0,0,1,1.338.284,5.219,5.219,0,0,1,1.651,1.157,10.231,10.231,0,0,1,1.622,2.219,29.2,29.2,0,0,1,3.063,11.588c0,.044.007.087.007.131.1,1.178.153,2.379.146,3.579l.1,15.589.065,9.3.2,29.17.073,10.358L742,675.929h0a1.455,1.455,0,0,1-1.455,1.455H734.7a1.455,1.455,0,0,1-1.455-1.455Z",
    transform: "translate(-243.189 -486.21)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M815.022,726.163l-5.608-9.013-1.12,5.15c-.2.9-.393,1.819-.575,2.728-1.593-1.36-3.288-2.619-4.946-3.826q-7.638-5.543-15.269-11.1l1.593,9.238c.982,5.688,2.008,11.493,4.437,16.694.269.589.56,1.171.873,1.739h23.67a7.631,7.631,0,0,0,.393-1.629.554.554,0,0,0,.007-.109C818.849,732.505,816.9,729.182,815.022,726.163Z",
    transform: "translate(-381.213 -547.238)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M375.022,726.163l-5.608-9.013-1.12,5.15c-.2.9-.393,1.819-.575,2.728-1.593-1.36-3.288-2.619-4.946-3.826q-7.638-5.543-15.269-11.1l1.593,9.238c.982,5.688,2.008,11.493,4.437,16.694.269.589.56,1.171.873,1.739h23.67a7.632,7.632,0,0,0,.393-1.629.575.575,0,0,0,.007-.109C378.849,732.505,376.9,729.182,375.022,726.163Z",
    transform: "translate(-236.547 -547.238)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M928.4,748.851l-200.587.223a.866.866,0,0,1,0-1.732l200.587-.223a.866.866,0,0,1,0,1.732Z",
    transform: "translate(-364.712 -557.328)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M396.4,748.851l-200.587.223a.866.866,0,0,1,0-1.732l200.587-.223a.866.866,0,1,1,0,1.732Z",
    transform: "translate(-194.969 -557.328)",
    fill: "#cacaca"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8816",
    "data-name": "Group 8816",
    transform: "translate(453.048 332.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    width: 13.151,
    height: 13.151,
    transform: "translate(73.787 24.827)",
    fill: "#a47cea",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M141.65,641.12c.421.24.851.462,1.286.7v-.231h3.7v2.081l.786.365v-2.446h3.7v4a1.158,1.158,0,0,0,.222.083V641.12Z",
    transform: "translate(-98.216 -570.436)",
    fill: "#a47cea",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 2.899,
    height: 65.278,
    transform: "translate(59.706 7.172)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M176.78,639.36l-.18,2.941-.259,4.162-.106,1.729-.254,4.162-.111,1.729-.259,4.162-2.922,47.2a8,8,0,0,1-7.981,7.5H149.512a8,8,0,0,1-7.977-7.5l-2.909-47.231-.259-4.162-.106-1.729L138,648.16l-.106-1.729-.259-4.162-.185-2.941a4.162,4.162,0,0,1,4.162-4.4h31.079a4.134,4.134,0,0,1,4.088,4.43Z",
    transform: "translate(-95.956 -567.108)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M129.561,592.24l-.259,4.148H90.839l-.259-4.148Z",
    transform: "translate(-48.917 -517.048)",
    fill: "#9ca8b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M129.62,604.95l-.254,4.152H91.629l-.259-4.152Z",
    transform: "translate(-49.342 -523.88)",
    fill: "#9ca8b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M129.68,617.68l-.254,4.148H92.419l-.259-4.148Z",
    transform: "translate(-49.766 -530.724)",
    fill: "#9ca8b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M84.974,541.67c16.883,12.217,23.93,31.324,23.93,31.324s-20.346-.7-37.233-12.915S47.75,528.76,47.75,528.76,68.087,529.454,84.974,541.67Z",
    transform: "translate(-47.736 -510.032)",
    fill: "#75a5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M47.72,528.76s21.123,11.722,27.9,21.428,33.27,22.806,33.27,22.806",
    transform: "translate(-47.72 -510.032)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M128.263,495.289c9.188,6.645,13.031,17.044,13.031,17.044s-11.075-.379-20.267-7.024S108,488.26,108,488.26,119.07,488.639,128.263,495.289Z",
    transform: "translate(-80.126 -488.26)",
    fill: "#75a5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10824",
    "data-name": "Path 10824",
    d: "M108,488.26s11.5,6.381,15.181,11.662,18.113,12.411,18.113,12.411",
    transform: "translate(-80.126 -488.26)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10825",
    "data-name": "Path 10825",
    d: "M193.98,521.439c-10.557,11.6-12.79,26.764-12.79,26.764s14.885-3.653,25.433-15.259,12.79-26.764,12.79-26.764S204.537,509.838,193.98,521.439Z",
    transform: "translate(-119.472 -497.894)",
    fill: "#75a5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10826",
    "data-name": "Path 10826",
    d: "M219.422,506.19s-13.752,11.893-17.248,20.087-20.984,21.932-20.984,21.932",
    transform: "translate(-119.472 -497.899)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8829",
    "data-name": "Group 8829",
    transform: "translate(122.912 213.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10855",
    "data-name": "Path 10855",
    d: "M369.338,520.579a131.075,131.075,0,0,1,10.848-41.368q2.448-5.469,5.389-10.7a.8.8,0,0,0-1.378-.806A132.882,132.882,0,0,0,369.411,508.5q-1.11,6-1.669,12.075C367.648,521.6,369.245,521.595,369.338,520.579Z",
    transform: "translate(-348.928 -450.851)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_368",
    "data-name": "Ellipse 368",
    cx: 10.111,
    cy: 10.111,
    r: 10.111,
    transform: "translate(30.403 0)",
    fill: "#1157a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10856",
    "data-name": "Path 10856",
    d: "M370.263,519.526a85.036,85.036,0,0,1,7.038-26.837q1.589-3.548,3.5-6.94a.518.518,0,1,0-.894-.523,86.207,86.207,0,0,0-9.594,26.462q-.72,3.89-1.082,7.836C369.166,520.189,370.2,520.186,370.263,519.526Z",
    transform: "translate(-348.818 -449.531)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 6.559,
    cy: 6.559,
    r: 6.559,
    transform: "translate(27.927 24.761)",
    fill: "#1157a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10857",
    "data-name": "Path 10857",
    d: "M369.9,518.88a85.038,85.038,0,0,1-10.957-25.489q-.93-3.775-1.512-7.623a.518.518,0,0,0-1.026.138,86.208,86.208,0,0,0,8.714,26.769q1.825,3.511,3.966,6.844C369.447,520.076,370.261,519.437,369.9,518.88Z",
    transform: "translate(-349.767 -449.503)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_370",
    "data-name": "Ellipse 370",
    cx: 6.559,
    cy: 6.559,
    r: 6.559,
    transform: "translate(0.074 24.3)",
    fill: "#1157a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10858",
    "data-name": "Path 10858",
    d: "M350.224,523.2V510.312a4.838,4.838,0,0,1,4.833-4.833h30.072a4.838,4.838,0,0,1,4.833,4.833V523.2a4.838,4.838,0,0,1-4.833,4.833H355.057a4.839,4.839,0,0,1-4.833-4.832Z",
    transform: "translate(-350.224 -448.019)",
    fill: "#ccc"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M80.987,236.107h108.94a5.972,5.972,0,0,0,0-11.945H80.987a5.972,5.972,0,0,0,0,11.945Zm84.053-36.164H105.861v18.837h59.179Z",
    transform: "translate(162.067 50.815)",
    fill: "#3f3d56",
    fillRule: "evenodd"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1718",
    "data-name": "Rectangle 1718",
    width: 218.227,
    height: 128.026,
    rx: 10,
    transform: "translate(189.863 117.115)",
    fill: "#3f3d56"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8835",
    "data-name": "Group 8835",
    transform: "translate(114.999 481.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11032",
    "data-name": "Path 11032",
    d: "M802.988,360.727l15.895,31.464,47.514,21.6c5.075,8.577,21.2,9.233,22.374,3.689,1.317-6.222-19.584-16.234-19.584-16.234L829.44,374.365l-3.479-23.144Z",
    transform: "translate(-752.603 -242.292)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11033",
    "data-name": "Path 11033",
    d: "M728.864,464.214l-2.931,23.447,17,1.173,1.756-24.619Z",
    transform: "translate(-676.604 -134.637)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11034",
    "data-name": "Path 11034",
    d: "M864.7,676.193a46.025,46.025,0,0,1-4.192-5.13c-2.433-3.372-4.6,13.922-4.6,13.922s-2.345,7.034-1.756,10.551,14.068,3.517,16.413,2.933,14.068,0,14.068,0h17.586c15.242-7.034,0-11.724,0-11.724-4.69-.586-20.516-15.242-20.516-15.242l-3.517-6.448c-2.344-.586-4.69,8.206-4.69,8.206Z",
    transform: "translate(-810.099 -326.685)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11035",
    "data-name": "Path 11035",
    d: "M789,464.615l-2.933,23.446,17,1.173,1.756-24.619Z",
    transform: "translate(-780.71 -134.744)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11036",
    "data-name": "Path 11036",
    d: "M924.838,676.6a46.082,46.082,0,0,1-4.192-5.13c-2.436-3.372-4.6,13.922-4.6,13.922s-2.344,6.448-1.756,9.965,14.068,3.514,16.413,2.933,14.068.586,14.068.586h17.586c15.242-7.034,0-11.724,0-11.724-4.69-.587-20.516-15.242-20.516-15.242l-3.517-6.448c-2.344-.586-4.69,8.206-4.69,8.206Z",
    transform: "translate(-914.197 -326.793)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11037",
    "data-name": "Path 11037",
    d: "M883.779,446.09c-2.345,2.933-1.172,12.9-1.172,12.9s-4.1,32.24-2.344,35.171-1.172,5.275-2.933,9.379-3.518,14.068-3.518,14.068c-9.965,8.206-9.379,45.723-9.379,45.723l-3.514,33.412c1.172,3.517,17.586,4.1,19.932,3.517s9.379-53.341,9.379-53.341l15.827-29.9s-1.172,79.721-1.172,83.241,15.827,1.756,19.344,1.756,3.517-58.62,3.517-58.62l3.517-15.24L950.021,458.4V450.2l-2.933-4.1S886.123,443.159,883.779,446.09Z",
    transform: "translate(-856.139 -267.456)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11038",
    "data-name": "Path 11038",
    d: "M919.82,251.326c-3.683,8.206-1.5,19.661,5.866,32.24L895.79,269.5l4.69-4.1-1.169-11.722Z",
    transform: "translate(-857.302 -215.429)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 18.173,
    cy: 18.173,
    r: 18.173,
    transform: "translate(35.259 9.226)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11039",
    "data-name": "Path 11039",
    d: "M907.631,275.259c3.915,2.327,6.257,6.6,7.6,10.956a103.824,103.824,0,0,1,4.46,24.8l1.419,25.2L938.7,403.047c-15.24,12.9-24.03,9.965-44.55-.586s-22.862,3.52-22.862,3.52-1.756-.586,0-2.344,0,0-1.756-1.756,0,0,.586-1.756,0-.587-.586-1.172,2.344-5.866,2.344-5.866l-4.687-43.967-5.866-62.136c7.034-8.793,26.963-16.413,26.963-16.413l18.175,12.9c5.866,2.344,1.172-7.034,1.172-7.034Z",
    transform: "translate(-845.112 -220.605)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11040",
    "data-name": "Path 11040",
    d: "M929.292,343.937l-2.344,35.172,29.9,42.792c0,9.965,5.275,12.31,5.275,12.31a77.5,77.5,0,0,0,5.275-9.965c2.933-6.448-1.756-11.724-1.756-11.724l-20.516-43.377,8.793-21.689Z",
    transform: "translate(-922.755 -240.335)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11041",
    "data-name": "Path 11041",
    d: "M949.18,292.977c-9.965,3.517-11.724,41.621-11.724,41.621,11.724-6.448,25.792,4.1,25.792,4.1s2.933-9.965,6.448-22.861a22.4,22.4,0,0,0-4.69-21.1S959.151,289.46,949.18,292.977Z",
    transform: "translate(-932.683 -226.304)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11042",
    "data-name": "Path 11042",
    d: "M16.791,27.707c2.021.263,3.546-1.8,4.251-3.717s1.249-4.136,3-5.169c2.4-1.41,5.472.286,8.216-.178,3.1-.525,5.115-3.811,5.274-6.95s-1.092-6.155-2.319-9.054l-.428,3.6A7.136,7.136,0,0,0,31.67,0l.549,5.279A5.6,5.6,0,0,0,25.778.643l.089,3.145a52.106,52.106,0,0,0-10.793-.529A17.43,17.43,0,0,0,5.151,7.085C1.081,10.624-.406,16.448.089,21.817s2.719,10.415,5.03,15.29C5.7,38.333,6.5,39.716,7.852,39.872a2.754,2.754,0,0,0,2.7-2.033,7.362,7.362,0,0,0-.033-3.617,15.351,15.351,0,0,1-.446-5.473c.319-1.813,1.625-3.606,3.453-3.828s3.7,1.868,2.82,3.489Z",
    transform: "translate(31.613 0)",
    fill: "#2f2e43"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8838",
    "data-name": "Group 8838",
    transform: "translate(704.551 487.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11043",
    "data-name": "Path 11043",
    d: "M341.465,288.441c-1.53,6.131.516,11.883,4.571,12.849s8.58-3.223,10.11-9.356a15.249,15.249,0,0,0,.085-7.464l6.142-26.057-12.769-2.6-4.7,25.966a15.469,15.469,0,0,0-3.442,6.669Z",
    transform: "translate(-340.957 -106.441)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8836",
    "data-name": "Group 8836",
    transform: "translate(6.89 331.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11044",
    "data-name": "Path 11044",
    d: "M310.692,566.9l-.787,17.08.788,4.726-2.757,5.514-21.662,2.363-1.182-10.237,11.422-5.907.332-9.648Z",
    transform: "translate(-263.551 -566.9)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11045",
    "data-name": "Path 11045",
    d: "M307.633,604.8l1.182,1.575,22.687-6.537s-1.024,10.08-1.024,12.052-37.415,1.969-43.045,1.182-3.822-5.908-3.822-5.908l23.348-11.05.676,8.686Z",
    transform: "translate(-283.334 -579.057)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8837",
    "data-name": "Group 8837",
    transform: "translate(75.061 318.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11046",
    "data-name": "Path 11046",
    d: "M194.516,545.365l4.721,16.433,2.259,4.222-.848,6.106L180.882,581.3l-4.4-9.325,8.93-9.25-5.6-14.526Z",
    transform: "translate(-159.11 -545.365)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11047",
    "data-name": "Path 11047",
    d: "M192.427,590.866l1.624,1.116,19.4-13.451s2.257,9.879,2.887,11.745-34.823,13.836-40.406,14.89-5.511-4.374-5.511-4.374L189,582.851Z",
    transform: "translate(-170.423 -559.166)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11048",
    "data-name": "Path 11048",
    d: "M246.994,81.834l-.827,13.433,25.082,1.273-7.767-17.7Z",
    transform: "translate(-194.492 -32.803)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11049",
    "data-name": "Path 11049",
    d: "M255.821,103.531c6.723,3,17.476,2.178,29.662,0l1.907,84.426s-38.122,7.664-51.228-6.477l6.9-68.981,12.762-8.968h0Z",
    transform: "translate(-204.784 -43.077)",
    fill: "#1157a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11050",
    "data-name": "Path 11050",
    d: "M191.225,240.579l53.82,5.319L271.6,426.229H251.251L216.4,302.664,213.645,442.7H195.019L179.15,271.277Z",
    transform: "translate(-155.71 -100.104)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11051",
    "data-name": "Path 11051",
    d: "M217.32,94.671l18.082,10.7a17.41,17.41,0,0,1,7.841,19.875l-13.974,47.73s22.756,39.1,15.362,42.544c-16.617,7.748-41.412,5.863-41.412,5.863l5.542-93.6,8.56-33.112h0Z",
    transform: "translate(-144.271 -39.389)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11052",
    "data-name": "Path 11052",
    d: "M327.674,102.924l-20.445,7.943L302.4,169.848l-13.523,47.514c22.9,8.361,20.766,4.463,20.766,4.463l3.794-81.985,14.237-36.913h0Z",
    transform: "translate(-275.852 -42.823)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11053",
    "data-name": "Path 11053",
    d: "M321.941,220.871l.07-.324,20.9-96.662a8.311,8.311,0,0,0-16.2-3.722l-22.955,94.359,18.187,6.347Z",
    transform: "translate(-299.985 -47.338)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 20.349,
    cy: 20.349,
    rx: 20.349,
    ry: 20.349,
    transform: "translate(43.039 11.902)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11054",
    "data-name": "Path 11054",
    d: "M219.566,5.88c-4.482,1.575-7.047,2.479-9.4,4.74-3.967,3.823-4.624,8.932-5.232,13.68-.476,3.714-1.092,8.516,1.085,14,.744,1.872,4.343,10.214,11.233,11.266,1.353.207,4.531.262,3.614-.415-8.476-6.257-12.093-10.034-11.8-19.677.186-5.992,9.34-12.459,14.777-13.624a9.259,9.259,0,0,1,7.523,1.752c4.569,3.751,4.375,19.263,9.193,22.505,1.984,1.334.661-8.053,2.057-6.532,2.754,3,.988,7.6.493,9.354-2.348,8.311-4.806,2.166-7.1,9.261-2.476,7.66,19.243,12.818,19.98,14.529,1.286,2.975-17.079,17.094-12.038,19.543,6.4,3.109,11.442-.94,14.416,2.533,1.663,1.94.763,4,3.767,10.031.981,1.971,1.473,2.956,1.9,2.92,2.054-.165,5.379-16.6,0-31.913-2.257-6.425-4.468-12.721-10.392-17.642-3.134-2.6-5.761-3.539-6.509-6.576-1.069-4.343,3.369-6.195,4.259-13.044.608-4.684,1.035-11.385-.62-15.683-1.563-4.056-2.918-7.576-6.468-10.768-.855-.769-7.734-5.981-15.032-6.127-3.358-.068-5.827,4.512-9.722,5.881h0Z",
    transform: "translate(-165.86 0.006)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055",
    "data-name": "Path 11055",
    d: "M242.165,211.827c-6.282-.661-11.7,2.17-12.088,6.316s4.386,8.048,10.672,8.709a15.255,15.255,0,0,0,7.4-.953l26.661,2.453.8-13-26.368-1.038a15.47,15.47,0,0,0-7.081-2.479Z",
    transform: "translate(-189.446 -88.1)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11056",
    "data-name": "Path 11056",
    d: "M216.117,113.965h0a12.384,12.384,0,0,1,13.848,9.712c4.679,22.25,13.079,69.647-.113,70.437-17.246,1.035-33.8-3.1-33.8-3.1l4.139-23.8,13.451-1.38-7.91-37.01a12.387,12.387,0,0,1,10.383-14.858Z",
    transform: "translate(-130.915 -47.368)",
    fill: "#3f3d58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLeftImg);
export default __webpack_public_path__ + "static/media/desktop-left-img.f41ee5dc08ecaa3365f7e023e332d50a.svg";
export { ForwardRef as ReactComponent };